/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import { motion } from 'framer-motion';
import { BiMenuAltRight } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import swLogo from '../../assets/icons/SW LOgo 1.svg';
// import swLogo from '../../assets/icons/republicdaylogo.png';
// import swLogo from '../../assets/icons/fiveYearlogo.svg';
// import swLogo from '../../assets/icons/logoChristmas.png';
import { handleSidebarOpen } from '../../redux/layout';
import { navLinks } from '../../utils/constants';

const userNavigation = [
  { name: 'Your Profile', href: '#' },
  { name: 'Settings', href: '#' },
  { name: 'Sign out', href: '#' },
];

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = () => {
    // temporary function just to see the UI functionality
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="sticky top-0 z-30 flex-shrink-0 flex h-16 bg-white ">
      {/* <button
        type="button"
        className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 lg:hidden"
        onClick={() => dispatch(handleSidebarOpen(true))}
      >
        <span className="sr-only">Open sidebar</span>
        <HiOutlineMenuAlt2 className="h-6 w-6" aria-hidden="true" />
      </button> */}
      <div className="flex-1 px-4 flex justify-between items-center lg:px-[6.4rem]">
        <div className=" hidden lg:block scale-[70%]  lg:max-h-max  ">
          <motion.img
            whileHover={{ scale: 1.2 }}
            transition={{
              type: 'spring',
              damping: 20,
            }}
            src={swLogo}
            alt="sw logo"
            className="lg:h-[12dvh] max-h-[3.7rem] contrast-125 brightness-90"
          />
        </div>

        <button
          onClick={() => dispatch(handleSidebarOpen(true))}
          className="w-[9rem] md:w-[13rem] lg:hidden"
        >
          <img src={swLogo} alt="sw logo" />
        </button>

        <div className="flex items-center  gap-1 md:gap-2">
          <a className="bg-primary-500 text-white px-2 text-sm md:text-base md:px-3 py-2 rounded-full inline-block lg:hidden">Get a Quote</a>
          <button title="menu" className="lg:hidden font-bold text-lg text-dark-500" onClick={() => dispatch(handleSidebarOpen(true))}><BiMenuAltRight /></button>
        </div>

        <div className="relative rounded-lg flex items-center gap-6 hidden lg:flex">
          {
            navLinks.map((el) => <a key={el.title} className="text-sm font-semibold hover:text-primary-500 transition hover:scale-125 duration-500" href={el.to} target={el?.target === 'self' ? '_self' : '_blank'} rel="noreferrer">{el.title}</a>)
          }

          <a className="bg-primary-500 text-white text-nowrap px-3 py-2 rounded-full" target="_self" href="#contact" rel="noreferrer">Get a Quote</a>
        </div>
        {/* <div className="ml-4 flex items-center lg:ml-6"> */}
        {/* <button
            type="button"
            className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <span className="sr-only">View notifications</span>
            <HiOutlineBell className="h-6 w-6" aria-hidden="true" />
          </button> */}

        {/* Profile dropdown */}
        {/* <Menu as="div" className="ml-3 relative">
            <div>
              <Menu.Button className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                <span className="sr-only">Open user menu</span>
                <img
                  className="h-8 w-8 rounded-full"
                  src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEylgd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                  alt=""
                />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-lg shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                {userNavigation.map((item) => (
                  <Menu.Item key={item.name}>
                    {({ active }) => (
                      <a
                        href={item.href}
                        onClick={logout}
                        className={classNames(
                          active ? 'bg-gray-100' : '',
                          'block px-4 py-2 text-sm text-gray-700',
                        )}
                      >
                        {item.name}
                      </a>
                    )}
                  </Menu.Item>
                ))}
              </Menu.Items>
            </Transition>
          </Menu> */}
        {/* </div> */}
      </div>
    </div>
  );
}
